import React, { useState } from 'react'
import {Link} from 'react-router-dom'
import './Header.css'
import SumoIcon from '../images/logo_new_white.png'
import Menu from '../../node_modules/@mui/material/Menu'
import MenuItem from '../../node_modules/@mui/material/MenuItem'
import Rocket from './Rocket'
import Environment from './env_var'

const Header = (props) => {
	
	const [anchorEl, setAnchorEl] = useState(null)

	const handleClick = (event) => {
		event.persist()
		setAnchorEl(event.target)
	}

	const handleClose = (e) => {
		setAnchorEl(null)
		if (e.target.innerHTML === 'Sharing Bar') {
			props.showSocialSharingDialog()
		}
	}

	const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
	: Environment.environment.stagingURL

	return (
		<div className='header'>
			<div className='logo-container'>
				<div className='sumo-icon-header-container'>
					<img className='logo'  src={SumoIcon} alt='Sumo' onClick={handleClick} />
				</div>
				<Link 
					className='icon-link' 
					to={{
						pathname: '/launchpad-guided'
					}}
				><Rocket /></Link>
			</div>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem onClick={handleClose}><a href={fetchDomain} target='_blank' rel='noreferrer' >Homepage</a></MenuItem>
				<MenuItem onClick={handleClose}><a href={`${fetchDomain}/manage/my-settings.php`} target='_blank' rel='noreferrer' >Settings</a></MenuItem>
				<MenuItem onClick={handleClose}><a href={`${fetchDomain}/manage/my-wallet.php`} target='_blank' rel='noreferrer' >Wallet</a></MenuItem>
				<MenuItem onClick={handleClose}>
					<Link 
						to={{
							pathname: props.isLoggedIn ? '/logout':'/login',
						}}
						state={{
							isLoggedIn: props.isLoggedIn
						}}
					>{props.isLoggedIn ? 'Logout' : 'Login'}</Link>
				</MenuItem>
				{props.showSocialSharingDialog && <MenuItem onClick={handleClose}>
					<button className='sharing-bar'>Sharing Bar</button>
				</MenuItem>}
				<MenuItem onClick={handleClose}><a href='https://tawk.to/chat/607c5fccf7ce1827093b9362/1f3itceal' target='_blank' rel='noreferrer' >Chat</a></MenuItem>
			</Menu>
			
	    </div>
	)
}

export default Header
